import axios from 'axios'
import qs from 'qs'
import getGlobalParams from './changba-global-params'
import { getQueryStrFn } from './Util.js'

const symbolJson = Symbol('json')

// 创建axios实例
const instance = axios.create({
  timeout: 30000,
  transformRequest: [function(data, headers) {
    if (data instanceof FormData) {
      return data
    }

    if (data?.[symbolJson] === true) {
      headers['Content-Type'] = 'application/json; charset=utf-8'

      return JSON.stringify(data)
    }

    return qs.stringify(data)
  }]
})

// request拦截器
instance.interceptors.request.use(config => {
  if (config.method === 'get') {
    config.params = config.data
  }

  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

export async function fetch(url, inputOptions = {}) {
  const isMock = getQueryStrFn("isMock")
  const mockPrefix = 'https://yapi.changbaops.com/mock/46/automan'
  // 如果是奥特曼系统的请求，需要放行https://changba.com/auto，或者已经是mock地址了
  if (isMock && !(/https?:\/\/changba\.com\/auto/.test(url)) && !(/^https?:\/\/yapi\.changbaops\.com/i.test(url))) {
    // 如果已经是绝对路径打头了，替换成奥特曼mock地址
    if(/^https?/.test(url)) {
      url = url.replace(/^https?:\/\/((www\.)|(mars\.))?changba\.com/i, mockPrefix)
    } else {
      // 否则直接添加前缀
      url = mockPrefix + url
    }
  }

  const options = { ...inputOptions }

  if (!options.method) {
    options.method = 'get'
  }

  if (!options.data) {
    options.data = {}
  }

  const globalParams = await getGlobalParams();

  // 自动添加 userId, token 参数
  if (!options.data.userid) {
    options.data.userid = globalParams.userId || undefined;
  }
  if (!options.data.token) {
    options.data.token = globalParams.token || undefined;
  }

  if (options.upload === true) {
    const fd = new FormData()

    for (const key in options.data) {
      if (Object.prototype.hasOwnProperty.call(options.data, key)) {
        const value = options.data[key]

        if (value === undefined) {
          continue
        }

        if (Array.isArray(value)) {
          value.forEach((item) => {
            fd.append(`${key}[]`, item)
          })
        } else {
          fd.append(key, value)
        }
      }
    }

    options.data = fd
  } else if (options.method === 'post' && options.json === true) {
    options.data[symbolJson] = true
  }

  if (options.method.toLowerCase() === 'get' && options.cache !== true) {
    options.data._ = String(+new Date()) + String(Math.floor(Math.random() * 9999))
  }

  if (!options.onUploadProgress && options.onUploadPercent) {
    options.onUploadProgress = (progressEvent) => {
      if (progressEvent.lengthComputable) {
        options.onUploadPercent(Math.floor((progressEvent.loaded / progressEvent.total) * 100), progressEvent)
      }
    }
  }

  return instance(url, options)
    .then((response) => {
      let data = response.data

      if (!data) {
        data = {}
      }

      data.$response = response

      return data
    })
    .catch((error) => {
      return {
        code: 99999,
        data: {},
        msg: error.msg,
        $response: error
      }
    })
}
